module.exports = __webpack_public_path__ + "friday.75ffffbb82798ca30cf2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/friday.svg?o83v8v
// module id = 1088
// module chunks = 0